import { Routes, Route } from 'react-router-dom';
import { Mindestbelegung } from './pages';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { WithLocationGuard } from '@/features/locationGuard/WithLocationGuard';
import { buildLink } from '@/utils';

export function Dienstplan() {
  return (
    <Routes>
      <Route
        path="/mindestbelegung/:weekday/:arbeitsbereichId"
        element={
          <WithLocationGuard land="DE" fallbackURL={buildLink('home')}>
            <WithFeatureFlags name="mindestbelegung">
              <Mindestbelegung />
            </WithFeatureFlags>
          </WithLocationGuard>
        }
      />
      <Route
        path="/mindestbelegung/:weekday"
        element={
          <WithLocationGuard land="DE" fallbackURL={buildLink('home')}>
            <WithFeatureFlags name="mindestbelegung">
              <Mindestbelegung />
            </WithFeatureFlags>
          </WithLocationGuard>
        }
      />
      <Route
        path="/mindestbelegung/"
        element={
          <WithLocationGuard land="DE" fallbackURL={buildLink('home')}>
            <WithFeatureFlags name="mindestbelegung">
              <Mindestbelegung />
            </WithFeatureFlags>
          </WithLocationGuard>
        }
      />
    </Routes>
  );
}
